<template>
  <v-container fluid class="ma-0 pa-0">
    <v-col class="ma-0 pa-0 pt-2 pb-2" cols="12">
      <v-row class="ma-0 pb-2" align="center">
        <v-col class="ma-0 pa-0 text-left" cols="4" @click="download(item)"
               :class="{'text-decoration-underline': item.status === 'COMPLETED', 'download': item.status === 'COMPLETED'}">
          {{getDownloadFileNameStatus()}}
        </v-col>
        <v-col class="ma-0 pa-0 text-left" cols="4">
          {{item.beginTime.replace('T', ' ').substring(0,16) + ' ~ ' + item.endingTime.replace('T', ' ').substring(0,16)}}
        </v-col>
        <v-col v-if="item.status === 'COMPLETED' || item.status === 'FAILED'" class="ma-0 pa-0 text-left" cols="4">
          <v-row class="ma-0 pa-0" align="center">
            <v-col v-if="item.status === 'COMPLETED'" class="ma-0 pa-0 text-left" cols="8">{{item.expiredTime.replace('T', ' ').substring(0,16)}}</v-col>
            <v-col v-else class="ma-0 pa-0 text-left" cols="8"></v-col>
            <v-col v-if="item.status === 'COMPLETED'" class="ma-0 pa-0 text-left text-decoration-underline share_btn" cols="2" @click="onClickShare(item)">{{tmb('titleShare')}}</v-col>
            <v-col v-else class="ma-0 pa-0 text-left text-decoration-underline share_btn" cols="2"></v-col>
            <v-col class="ma-0 pa-0 text-left" cols="2">
              <!-- file이 아직 생성 전이면, 버튼을 조건부로 렌더링 -->
              <v-btn v-if="item.status === 'COMPLETED' || item.status === 'FAILED'" id="back_clean_btn" width="2.5rem" height="2.5rem"
                     class="ma-0 pa-0" elevation="0" @click="onClickDelete(item)">
                <v-img max-height="3rem" max-width="3rem" class="ma-0 pa-0"
                       src="@/assets/images/close_round.png"></v-img>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="border-opacity-100" color="white"></v-divider> <!-- 흰색 라인(divider) 추가 -->
    </v-col>
    <DownloadShareDialog :dialogVisible="downloadShareDialogVisible"
                          @visible="downloadShareDialogVisibleFunc"
                          :item="currentItem" />
  </v-container>
</template>

<script>
import mixin from '@/mixin';
import DownloadShareDialog from './dialog/DownloadShareDialog.vue';
import { isEmpty } from 'lodash';
import { isMobile, isIOS, isAndroid, getUA } from 'mobile-device-detect';

export default {
  props: {
    downloadDataList: Array,
    item: Object
  },
  components: {
    DownloadShareDialog
},
  mixins: [mixin.common],
  data: () => ({
    downloadShareDialogVisible: false,
    currentItem: null
  }),
  methods: {
    downloadShareDialogVisibleFunc(visible) {
      this.downloadShareDialogVisible = visible;
    },
    onClickShare(item) {
      this.downloadShareDialogVisible = true;
      this.currentItem = item;
    },
    // 클라우드에 생성된 mp4파일을 삭제하고자 할때 나오는 팝업
    onClickDelete(item) {
      this.$dialog.confirm({
        title: this.tmb('deleteFile'),
        text: `${item.name}${this.tmb('deleteThisFile')}`,
        actions: {
          false: { color: 'white', text: this.t('cancel'), handle: () => { 
              this.downloadConfirmDialogVisible = false;
            }
          },
          true: { color: 'white', text: 'OK', handle: () => { 
              this.downloadConfirmDialogVisible = false;
              this.requestDelete(item.id);
            }
          }
        }
      });
    },
    getDownloadFileNameStatus() {
      const { name, status } = this.item;
      if(isEmpty(name) || status === 'CREATED' || status === 'PROCEEDING') {
        // fileName이 없다면 작성중인 것으로 가정
        return this.tmb('fileInProgress');
      } else if(status === 'FAILED') {
        return this.tmb('fileCreationFail');
      }
      // 위 조건이 아니면 무조건 fileName 반환
      return name + '.mp4';
    },
    async download(item) {
      if(item.status !== 'COMPLETED') return;
      const link = document.createElement("a");
      if (isMobile && isIOS) {
        this.$vloading.show();
        const res = await fetch(item.path);
        const data = await res.blob();
        this.$vloading.hide();
        const blob = new Blob([data], { type: 'video/mp4' });
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', item.name + ".mp4");
        link.setAttribute('target', '_blank');
        link.style.display = 'none';
        link.download = item.name + ".mp4";
        link.click();
        URL.revokeObjectURL(link);
        return;
      }
      link.href = item.path;
      link.download = `${item.name}.mp4`;
      link.click();
      
    },
    requestDelete(id) {
      this.$vloading.show();
      this.networkController.deleteRecodedVideo({}, id).then((res) => {
        this.$vloading.hide();
        this.showToastMessage(this.tmb('requestSuccess'));
        this.$emit('deleteSuccess', true);
      }).catch(error => {
        this.$vloading.hide();
        this.showToastMessage(this.tmb('requestFail'));
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.download {
  cursor: pointer;
}
.share_btn {
  cursor: pointer;
}
</style>